import React from 'react';
import { Icons as I } from '../pack-icons';

/**
 * AttentionPanel — list of items needing user action.
 * items: [{ kind:'warn'|'info'|'danger', title, sub, action, onAction? }]
 * Pass allClear=true (or empty items) to show "All clear" empty state.
 */
export default function AttentionPanel({ items, allClear }) {
  const empty = allClear || !items?.length;
  if (empty) {
    return (
      <section className="card attn-panel attn-clear">
        <span className="attn-clear-ico">
          <I.check size={16} />
        </span>
        <div className="attn-clear-text">
          <h3>All clear</h3>
          <p>No posts awaiting review, no expiring connections, the week ahead is scheduled.</p>
        </div>
      </section>
    );
  }
  return (
    <section className="card attn-panel">
      <div className="attn-head">
        <div>
          <div className="eyebrow"><span>Attention</span></div>
          <h3>
            {items.length} item{items.length === 1 ? '' : 's'} need a moment
          </h3>
        </div>
      </div>
      <div className="attn-list">
        {items.map((it, i) => (
          <div key={i} className={`attn-item attn-${it.kind}`}>
            <span className="attn-ico">
              {it.kind === 'warn' && <I.alert size={14} />}
              {it.kind === 'info' && <I.info size={14} />}
              {it.kind === 'danger' && <I.alert size={14} />}
            </span>
            <div className="attn-text">
              <div className="attn-title">{it.title}</div>
              <div className="attn-sub">{it.sub}</div>
            </div>
            {it.action && (
              <button className="btn btn-ghost btn-sm" onClick={it.onAction} type="button">
                {it.action} <I.arrowRight size={11} />
              </button>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
